import styled from 'styled-components';

export const WidgetContainer = styled.div`
  width: 300px;
  
  @media (max-width: 1199px) {
    display: none;
  }
  
  .widget {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 15px;
    margin-bottom: 20px;
    
    .widget-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 15px;
      color: var(--text-primary, #333);
    }
    
    .widget-link {
      display: block;
      text-align: center;
      color: var(--primary-color, #3366CC);
      font-size: 14px;
      padding: 5px;
      margin-top: 10px;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
  
  .protection-score-widget {
    .score-circle {
      position: relative;
      width: 100px;
      height: 100px;
      margin: 0 auto 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      
      .score-text {
        position: absolute;
        text-align: center;
        line-height: 1;
        
        .score {
          font-size: 24px;
          font-weight: 700;
        }
        
        .label {
          font-size: 12px;
          color: var(--text-secondary, #666);
        }
      }
    }
    
    .protection-details {
      .protection-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        
        .item-label {
          width: 70px;
          font-size: 13px;
          color: var(--text-secondary, #666);
        }
        
        .progress-bar {
          flex: 1;
          height: 6px;
          background-color: var(--bg-soft, #f0f0f0);
          border-radius: 3px;
          margin: 0 10px;
          
          .progress {
            height: 100%;
            border-radius: 3px;
            background-color: var(--primary-color, #3366CC);
          }
        }
        
        .item-value {
          width: 40px;
          font-size: 13px;
          font-weight: 500;
          text-align: right;
        }
      }
    }
  }
  
  .alerts-widget {
    .alert-list {
      list-style: none;
      padding: 0;
      margin: 0;
      
      .alert-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid var(--border-light, #f0f0f0);
        
        &:last-child {
          border-bottom: none;
        }
        
        .alert-icon {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          flex-shrink: 0;
          
          i {
            font-size: 14px;
          }
        }
        
        &.alert-violation .alert-icon {
          background-color: var(--danger-soft, #FEE2E2);
          color: var(--danger, #DC2626);
        }
        
        &.alert-notification .alert-icon {
          background-color: var(--primary-soft, #DBEAFE);
          color: var(--primary, #3366CC);
        }
        
        &.alert-contract .alert-icon {
          background-color: var(--warning-soft, #FEF3C7);
          color: var(--warning, #F59E0B);
        }
        
        .alert-content {
          flex: 1;
          
          a {
            text-decoration: none;
            color: var(--text-primary, #333);
            font-size: 14px;
            
            &:hover {
              color: var(--primary, #3366CC);
            }
          }
        }
      }
    }
  }
  
  .trending-widget {
    .insight-list {
      list-style: none;
      padding: 0;
      margin: 0;
      
      .insight-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px solid var(--border-light, #f0f0f0);
        
        &:last-child {
          border-bottom: none;
        }
        
        .insight-icon {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          flex-shrink: 0;
          
          i {
            font-size: 14px;
          }
        }
        
        .insight-content {
          flex: 1;
          font-size: 14px;
          color: var(--text-primary, #333);
        }
      }
    }
  }
  
  .quick-actions-widget {
    .action-list {
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
      
      .action-button {
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 8px;
        background-color: var(--bg-soft, #f0f0f0);
        color: var(--text-primary, #333);
        text-decoration: none;
        transition: all 0.2s ease;
        
        &:hover {
          background-color: var(--primary-soft, #DBEAFE);
          color: var(--primary, #3366CC);
        }
        
        i {
          margin-right: 10px;
          font-size: 16px;
        }
        
        span {
          font-size: 14px;
        }
      }
    }
  }
`;